"use client";

import NavigationBar from "../components/NavBar";
import React, { useEffect, useState } from "react";
import styles from "../styles/home.module.css"; // Import CSS file

const HeroSection = () => {
  const [animateText, setAnimateText] = useState(false);

  useEffect(() => {
    setTimeout(() => setAnimateText(true), 500); // Delay animation
  }, []);

  return (
    <>
    <NavigationBar/>
    <section className={styles.heroContainer}>
      <div className={styles.textContainer}>

        <div className={styles.baseline}>
            <h1 className={`${styles.animatedText} ${animateText ? styles.show : ""}`}>
            " Simplifying rentals, <br />
            </h1>
        </div>

        <div className={styles.baseline}>
            <h1 className={`${styles.animatedText} ${animateText ? styles.show : ""}`}>
            Building trust. "
            </h1>
        </div>
        <div>
        <p className={styles.secondarytags}>
          BD’s first thematic rental service facility is now here. Your world of subtle home renting is now a responsibility.
        </p>
        <button className={styles.ctaButton}>Get Started!</button> 
        </div>
      </div>

      {/* Right Side: Hero Image with Gradient Effect */}
      <div className={styles.imageContainer}>
        <img src="/Hero.jpg" alt="Hero" layout="fill" objectFit="cover" />
        <div className={styles.gradientOverlay}></div> {/* Gradient effect */}
      </div>
    </section>


    {/* second section */}

    <section className={styles.findHomeSection}>

      <div className={styles.textContent}>
        <h2 className={styles.heading}>Find your perfect home.</h2>
        <p className={styles.subtext}>Looking for rent? Search now.</p>
        <div className={styles.searchContainer}>
          <input type="text" placeholder="Enter location, city, or zip code" className={styles.searchInput} />
          <button className={styles.searchButton}>Search</button>
        </div>
      </div>

      <div className={styles.imageContainer}>
        <div className={styles.stackedImages}>
          <img src="/secondhero.png" alt="Home 1" className={styles.imageOne} />
        </div>
      </div>

      <div className={styles.gradientOverlay}></div>
    </section>


    <section className={styles.signUpSection}>
      <div className={styles.leftSection}></div>

      <div className={styles.rightSection}>
        <h2 className={styles.heading}>Sign Up and Get Pre-Approved.</h2>
        <p className={styles.subtext}>
          What type of houses are you looking for?<br />
          Apply and our team will reach out.
        </p>
        <button className={styles.signupButton}>Sign Up!</button>
      </div>
    </section>


    <footer className={styles.footer}>
      <p className={styles.footerText}>
        © 2025 RentEase. Simplifying Rentals, Building Trust. <br />
        Find your perfect home with ease and confidence.
      </p>
      
      <p className={styles.footerText}>Follow us on:</p>
      
      <div className={styles.socialLinks}>
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
          <img src="/facebook.svg" alt="Facebook" className="socialIcon" />
        </a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
          <img src="/instagram.svg" alt="Instagram" className="socialIcon" />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <img src="/twitter.svg" alt="Twitter" className="socialIcon" />
        </a>
      </div>
    </footer>

    </>
  );
};

export default HeroSection;

